import serviceHTTPHelper from './service-http-helper';

var FeatureFlagSDKModule = function FeatureFlagSDKModule(ServiceSDK, config) {
  function featureFlagsRoute(endpoint) {
    return ServiceSDK.nwApiRoute(config.featureFlagsBaseUrl, 'features', 1, endpoint);
  }

  var service = serviceHTTPHelper(ServiceSDK, featureFlagsRoute);

  function getAll(serverRequest) {
    return service.get('/feature_flags/all', {}, serverRequest);
  }

  function getByTitle(title, serverRequest) {
    return service.get("/feature_flags/title/".concat(title), {}, serverRequest);
  }

  function bulkGetByTitle(titles, serverRequest) {
    return service.post('/feature_flags/bulk', {
      titles: titles
    }, serverRequest);
  }

  return {
    ServiceSDK: ServiceSDK,
    getAll: getAll,
    getByTitle: getByTitle,
    bulkGetByTitle: bulkGetByTitle
  };
};

export default FeatureFlagSDKModule;